import React from 'react'
import { Select } from "antd"

const FilterSelect = ({ options, onChangeSelect, placeholder }) => {

    const _handleChangeSelect = value => {
        onChangeSelect(value)
    }

    return (
        <div className='FilterSelect'>
            <Select
                defaultValue={[]}
                onChange={_handleChangeSelect}
                style={{ minWidth: "100%" }}
                allowClear
                placeholder={placeholder}
            >
                {options.length && options.map((option, index) => (
                    <Select.Option value={option.value} key={index}>{option.name}</Select.Option>
                ))}
            </Select>
        </div>
    )
}

export default FilterSelect
